import { render, staticRenderFns } from "./AdminProductionTypeEditModal.vue?vue&type=template&id=3397d98c"
import script from "./AdminProductionTypeEditModal.vue?vue&type=script&lang=js"
export * from "./AdminProductionTypeEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3397d98c')) {
      api.createRecord('3397d98c', component.options)
    } else {
      api.reload('3397d98c', component.options)
    }
    module.hot.accept("./AdminProductionTypeEditModal.vue?vue&type=template&id=3397d98c", function () {
      api.rerender('3397d98c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminProductionTypeEditModal.vue"
export default component.exports